// PLUGINS IMPORTS //
import React from "react"
import styled from "styled-components"

// COMPONENTS IMPORTS //
import LanguageItem from "./LanguageItem/LanguageItem"
import { memoComparison } from "Content/Shared/Helpers/Functions/Functions"

// EXTRA IMPORTS //
import { iPhoneResolution } from "Content/Shared/Styles/Theme"

import EnglishFlag from "Assets/Images/flags/english.svg"
import RussianFlag from "Assets/Images/flags/russian.svg"
import GermanFlag from "Assets/Images/flags/german.svg"
import SpanishFlag from "Assets/Images/flags/spanish.svg"
import CatalanFlag from "Assets/Images/flags/spanish.svg"

/////////////////////////////////////////////////////////////////////////////

type PropsType = {}

const LanguageBackground: React.FC<PropsType> = () => {
  const colors = {
    green: "rgb(62, 194, 68)",
    orange: "orange",
  }
  const data = [
    {
      flag: RussianFlag,
      title: "Russian",
      level: "Native",
      color: colors.green,
    },
    {
      flag: EnglishFlag,
      title: "English",
      level: "Fluent",
      color: colors.green,
    },
    {
      flag: SpanishFlag,
      title: "Spanish",
      level: "Fluent",
      color: colors.green,
    },

    {
      flag: GermanFlag,
      title: "German",
      level: "Intermidiate",
      color: colors.orange,
    },
    {
      flag: CatalanFlag,
      title: "Catalan",
      level: "Beginner",
      color: colors.orange,
    },
  ]

  return (
    <>
      <Title>Languages background</Title>
      <LanguagesList>
        {data.map((item) => (
          <LanguageItem
            flag={item.flag}
            title={item.title}
            level={item.level}
            color={item.color}
          />
        ))}
      </LanguagesList>
    </>
  )
}

const Title = styled.h3`
  margin-bottom: 25px;
  margin-top: 30px;
`

const LanguagesList = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  @media (max-width: ${iPhoneResolution}px) {
    justify-content: space-between;
  }
`

export default React.memo(LanguageBackground, memoComparison)
